module.exports = __webpack_public_path__ + "img/hakuna_price_xmas.1ecc6e7d.png";